import { render } from "./TokenFieldMenu.vue?vue&type=template&id=645d7ce1&scoped=true"
import script from "./TokenFieldMenu.vue?vue&type=script&lang=js"
export * from "./TokenFieldMenu.vue?vue&type=script&lang=js"

import "./TokenFieldMenu.vue?vue&type=style&index=0&id=645d7ce1&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-645d7ce1"]])

export default __exports__